import { useEffect } from 'react';
import { User } from '../../shared/types/generated';
import { triggerEventCustom } from '../remote-education/remote-education-utils';
import { DOMAIN_SITE_URL } from '../../shared/constans';

export const EventAfterTip: React.FC<{
  user?: User;
  ammount?: string;
  session_id?: string;
}> = ({ ammount, session_id }) => {
  const event = `{
'event': 'contribution',
'pagePath': ${DOMAIN_SITE_URL}/planes,
'price': '${ammount}',
'stripe_session_id': '${session_id}',
}`;
  useEffect(() => {
    const timeout = setTimeout(() => {
      triggerEventCustom(event);
    }, 800);
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [event]);

  return <div></div>;
};
